<template>
<div>
    <div class="audio-container">
      <div class="player-container">
        
     
        <audio ref="audio-player" class="audio-player" controls>
           <source :src="url" type="audio/mpeg">
          :( Audio not supported..
        </audio>
      
      </div>
      <div class="toolbar" >
        <ui-icon icon="times" class="close" @click.native="close()"/>
      </div>
    </div>
  </div>
</template>

<script>
// Audio player in caroussel...


import UiIcon from '../../components/UiIcon.vue';

export default {
  name: 'audio-player',
  props: ['url'],
  data:function(){
    return {
     element:undefined,
     playing:false,
     player:undefined,
    }
  },
  components:{
    UiIcon,
  },
  methods:{
    close:function(){
      this.$emit("close");
    },
    addPlayer(){
      
      this.player=this.$refs['audio-player'];
      

   
    },
    removePlayer(){
      //this.player.pause();
    },
  },
  beforeDestroy(){
    this.removePlayer();
  },
  mounted:function(){
   this.addPlayer();
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.audio-container{

  z-index:200000;
  position:fixed;
  background-color:rgba(0, 0, 0, 1);
  display:flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  
}
.player-container{
  position:relative;
  flex:1;
  justify-content: center;
  align-items: center;
  display:flex;
}
.toolbar{
  text-align:right;
 position:relative;
 background-color:#000000;
 padding:10px;
}
.close{
  cursor:pointer;
  font-size:1.5em;
}

.audio-player{
  margin:10px;
  display:block;
  position:relative;
  width:100%;
}
.audio-player:focus {
 outline: none;
}


</style>
